import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SociopathTestReport from "./component";
import {
  getAssessment,
  getAssessmentAttemptByUserId,
  getInsightfulContent,
  sendToFriendReportOnEmail,
} from "../dashboard/actions";
import {
  createGuestUser,
  getBilling,
  getGuestUser,
  getOrderDataByUserId,
  getTransactionDetail,
  GetUserById,
  isGuestOrPremiumUser,
} from "../settings/actions";
import { getAssessmentResultByAssessmentAttemptId } from "../plan/actions";

const mapStateToProps = ({ funnelStep }) => ({ funnelStep });

// Only the actions the shared components (ShareButton, SendToFriendButton,
// CallToActionSection, InviteFriend) and the real content/result fetches
// need are bound here — imported directly from dashboard/settings/plan's
// actions.js, the same source every sibling report uses. This report has no
// real Redux state of its own, so it follows the established convention of
// borrowing actions rather than defining report-local ones (see
// actions.js/reducers.js/types.js — unused Ducks-module scaffolding, not
// wired into rootreducer.js).
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUserByIdConnect: GetUserById,
      getInsightfulContentConnect: getInsightfulContent,
      getAssessmentResultByAssessmentAttemptIdConnect:
        getAssessmentResultByAssessmentAttemptId,
      sendToFriendReportOnEmailConnect: sendToFriendReportOnEmail,
      getAssessmentConnect: getAssessment,
      getAssessmentAttemptByUserIdConnect: getAssessmentAttemptByUserId,
      getGuestUserConnect: getGuestUser,
      getTransactionDetailConnect: getTransactionDetail,
      getOrderDataByUserIdConnect: getOrderDataByUserId,
      guestUserChangesConnect: createGuestUser,
      getBillingConnect: getBilling,
      isGuestOrPremiumUserConnect: isGuestOrPremiumUser,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SociopathTestReport);
